<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { buzzSignalStyle } from './buzzSignalColors';

const props = defineProps({
  footfall: {
    type: Object,
    default: () => ({}),
  },
});

const { t } = useI18n();
const signalStyle = buzzSignalStyle('footfall');

const rows = computed(() => {
  const items = [];
  if (props.footfall?.live_busy_percent) {
    items.push({
      key: 'live',
      label: t('BUZZ_REPORTS.INSIGHTS.LIVE_BUSY'),
      value: `${Math.round(props.footfall.live_busy_percent)}%`,
      hint: props.footfall.live_busy_text,
    });
  }
  if (props.footfall?.weekend_peak) {
    items.push({
      key: 'weekend',
      label: t('BUZZ_REPORTS.INSIGHTS.WEEKEND_PEAK'),
      value: `${Math.round(props.footfall.weekend_peak)}%`,
    });
  }
  return items;
});
</script>

<template>
  <div v-if="rows.length" class="grid grid-cols-2 md:grid-cols-3 gap-3 mb-4">
    <div
      v-for="row in rows"
      :key="row.key"
      class="rounded-lg p-3"
      :class="signalStyle.fillClass"
    >
      <p class="text-xs mb-0" :class="signalStyle.textClass">{{ row.label }}</p>
      <p class="text-lg font-semibold text-n-slate-12 mb-0 mt-1">
        {{ row.value }}
      </p>
      <p v-if="row.hint" class="text-xs text-n-slate-10 mt-1 mb-0">
        {{ row.hint }}
      </p>
    </div>
  </div>
</template>
